if(navigator.userAgent.indexOf("Chrome-Lighthouse") == -1) {
  
  // Sistema de modal para medidor de tallas nuevo - Completamente independiente
  document.addEventListener('DOMContentLoaded', function() {
    
    // Variables del modal
    var modalNuevo = null;
    var isModalOpen = false;
    
    // Crear el modal usando Tingle
    function initTallaModal() {
      if (typeof tingle === 'undefined') {
        console.log('Tingle no está disponible, reintentando...');
        setTimeout(initTallaModal, 500);
        return;
      }
      
      modalNuevo = new tingle.modal({
        closeLabel: 'Cerrar',
        onClose: function() {
          isModalOpen = false;
        },
        onOpen: function() {
          isModalOpen = true;
          initAccordion();
          initCopyButton();
          initCloseButton();
        },
        cssClass: ['talla-modal-nuevo-container']
      });
      
      // Obtener el contenido del snippet
      var modalContent = document.querySelector('.talla-modal-nuevo');
      if (modalContent) {
        modalNuevo.setContent(modalContent.innerHTML);
      }
      
    }

    // Delegado: cubre los dos links que abren el modal (.btn-talla-nuevo y
    // .open-guiaTallasAb) sin importar cuántas copias haya de cada variante
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('.btn-talla-nuevo, .open-guiaTallasAb');

      if (!trigger) return;

      e.preventDefault();

      if (modalNuevo && !isModalOpen) {
        modalNuevo.open();
      }
    });
    
    
    // Nodo del modal de tallas, para no buscar en todo el documento
    // (hay otros .tingle-modal en el PDP: garantías, medidores viejos, etc.)
    function getModalRoot() {
      if (modalNuevo && modalNuevo.modal) {
        return modalNuevo.modal;
      }

      return document.querySelector('.talla-modal-nuevo-container');
    }

    // Funcionalidad del acordeón
    function initAccordion() {
      var root = getModalRoot();

      if (!root) return;

      var accordions = root.querySelectorAll('.talla-accordion');

      for (var i = 0; i < accordions.length; i++) {
        initSingleAccordion(accordions[i]);
      }
    }

    function initSingleAccordion(accordion) {
      var accordionHeader = accordion.querySelector('.talla-accordion-header'); 
      var accordionContent = accordion.querySelector('.talla-accordion-content');
      var accordionArrow = accordion.querySelector('.talla-arrow svg');

      if (!accordionHeader || !accordionContent) return;

      // Estado inicial: cerrado
      accordionContent.style.display = 'none';
      accordionHeader.classList.remove('active');
      if (accordionArrow) {
        accordionArrow.style.transform = 'rotate(0deg)';
      }

      // Agregar cursor pointer
      accordionHeader.style.cursor = 'pointer';

      // initAccordion() corre en cada onOpen, así que el listener se engancha
      // una sola vez: si no, el segundo click hacía toggle dos veces y el
      // acordeón ya no abría
      if (accordionHeader.dataset.tallaAccordionBound === 'true') return;
      accordionHeader.dataset.tallaAccordionBound = 'true';

      accordionHeader.addEventListener('click', function() {
        var isOpen = accordionContent.style.display !== 'none';

        if (isOpen) {
          // Cerrar acordeón
          accordionContent.style.display = 'none';
          accordionHeader.classList.remove('active');
          if (accordionArrow) {
            accordionArrow.style.transform = 'rotate(0deg)';
          }
        } else {
          // Abrir acordeón
          accordionContent.style.display = 'block';
          accordionHeader.classList.add('active');
          if (accordionArrow) {
            accordionArrow.style.transform = 'rotate(180deg)';
          }
        }
      });
    }
    
    // Funcionalidad del botón copiar
    function initCopyButton() {
      var root = getModalRoot();

      if (!root) return;

      var copyBtns = root.querySelectorAll('.talla-copy-btn');

      for (var i = 0; i < copyBtns.length; i++) {
        var copyBtn = copyBtns[i];

        // Mismo caso que el acordeón: un solo listener por botón
        if (copyBtn.dataset.tallaCopyBound === 'true') continue;
        copyBtn.dataset.tallaCopyBound = 'true';

        copyBtn.addEventListener('click', function() {
          var textToCopy = this.getAttribute('data-copy-text');
          
          // Crear elemento temporal para copiar
          var tempInput = document.createElement('textarea');
          tempInput.value = textToCopy;
          document.body.appendChild(tempInput);
          tempInput.select();
          
          try {
            document.execCommand('copy');
            
            // Solo texto "Copiado" sin cambios de estilo
            var originalText = this.innerHTML;
            this.innerHTML = 'Copiado';
            
            setTimeout(() => {
              this.innerHTML = originalText;
            }, 2000);
            
          } catch (err) {
            console.log('Error al copiar:', err);
          }
          
          document.body.removeChild(tempInput);
        });
      }
    }
    
    // Funcionalidad del botón de cerrar personalizado
    function initCloseButton() {
      var root = getModalRoot();

      if (!root) return;

      var closeBtns = root.querySelectorAll('.talla-modal-close');

      for (var i = 0; i < closeBtns.length; i++) {
        var closeBtn = closeBtns[i];

        // Mismo caso que el acordeón: un solo listener por botón
        if (closeBtn.dataset.tallaCloseBound === 'true') continue;
        closeBtn.dataset.tallaCloseBound = 'true';

        closeBtn.addEventListener('click', function() {
          if (modalNuevo) {
            modalNuevo.close();
          }
        });
      }
    }
    
    // Inicializar cuando esté listo
    initTallaModal();
  });
  
}
